if (!customElements.get('wt-benefits-product')) {
  customElements.define(
    'wt-benefits-product',
    class WtBenefitsProduct extends HTMLElement {
      connectedCallback () {
        this.imageWrapper = this.querySelector('.wt-benefits-product__img')
        this.iconItems = this.querySelectorAll('.wt-benefits-product__icon-item')

        if (!this.imageWrapper || !this.iconItems.length) return

        this.onIconInteract = this.onIconInteract.bind(this)

        this.iconItems.forEach((item) => {
          item.addEventListener('mouseenter', this.onIconInteract)
          item.addEventListener('click', this.onIconInteract)
        })
      }

      onIconInteract (event) {
        const item = event.currentTarget
        const heroSrc = item.getAttribute('data-hero-src')

        if (!heroSrc) return

        this.updateHeroImage(heroSrc)
      }

      updateHeroImage (src) {
        const existingImg =
          this.imageWrapper.querySelector('img.wt-benefits-product__hero')

        if (existingImg) {
          if (existingImg.getAttribute('src') === src) return

          existingImg.setAttribute('src', src)
          existingImg.removeAttribute('srcset')
          return
        }

        const img = document.createElement('img')
        img.className = 'wt-benefits-product__hero'
        img.src = src
        img.alt = ''
        img.loading = 'lazy'

        this.imageWrapper.innerHTML = ''
        this.imageWrapper.appendChild(img)
      }

      disconnectedCallback () {
        this.iconItems?.forEach((item) => {
          item.removeEventListener('mouseenter', this.onIconInteract)
          item.removeEventListener('click', this.onIconInteract)
        })
      }
    },
  )
}
